module.exports = __webpack_public_path__ + "usertx.png?297e9bfb9e2b45b4f87e608b846454ab";


//////////////////
// WEBPACK FOOTER
// ./static/images/usertx.png
// module id = 572
// module chunks = 26